<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="chapter_tit"><span><i>CONTENTS</i></span></p>
<p class="toc1"> </p>
<p class="toc1"><a href="#/index_split_002">Eight Years Previously…</a></p>
<p class="toc1"> </p>
<p class="toc1"><a href="#/index_split_003">01. Exile</a></p>
<p class="toc1"><a href="#/index_split_004">02. Protected or Hunted?</a></p>
<p class="toc1"><a href="#/index_split_005">03. Neptune’s Shadow</a></p>
<p class="toc1"><a href="#/index_split_006">04. Death Spiral</a></p>
<p class="toc1"><span href="#/index_split_007" title="Link target outside of Sample">05. Terminal Intention</span></p>
<p class="toc1"><span href="#/index_split_008" title="Link target outside of Sample">06. Suspicion</span></p>
<p class="toc1"><span href="#/index_split_009" title="Link target outside of Sample">07. Sushi for One</span></p>
<p class="toc1"><span href="#/index_split_010" title="Link target outside of Sample">08. Happy Returns</span></p>
<p class="toc1"><span href="#/index_split_011" title="Link target outside of Sample">09. Kolaportid</span></p>
<p class="toc1"><span href="#/index_split_012" title="Link target outside of Sample">10. Shadow in the Crowd</span></p>
<p class="toc1"><span href="#/index_split_013" title="Link target outside of Sample">11. Citizens Again</span></p>
<p class="toc1"><span href="#/index_split_014" title="Link target outside of Sample">12. Movie Night</span></p>
<p class="toc1"><span href="#/index_split_015" title="Link target outside of Sample">13. How to Control a Country</span></p>
<p class="toc1"><span href="#/index_split_016" title="Link target outside of Sample">14. It Can Be Done</span></p>
<p class="toc1"><span href="#/index_split_017" title="Link target outside of Sample">15. Synperco</span></p>
<p class="toc1"><span href="#/index_split_018" title="Link target outside of Sample">16. Feeding the Fish</span></p>
<p class="toc1"><span href="#/index_split_019" title="Link target outside of Sample">17. Neptune’s Welcome</span></p>
<p class="toc1"><span href="#/index_split_020" title="Link target outside of Sample">18. The Wrong Saboteur</span></p>
<p class="toc1"><span href="#/index_split_021" title="Link target outside of Sample">19. The Wrong Instinct</span></p>
<p class="toc1"><span href="#/index_split_022" title="Link target outside of Sample">20. Offshore Shuffle</span></p>
<p class="toc1"><span href="#/index_split_023" title="Link target outside of Sample">21. Neptune’s Volcano</span></p>
<p class="toc1"><span href="#/index_split_024" title="Link target outside of Sample">22. Black Death</span></p>
<p class="toc1"><span href="#/index_split_025" title="Link target outside of Sample">23. Out of the Frying Pan…</span></p>
<p class="toc1"><span href="#/index_split_026" title="Link target outside of Sample">24. News from Auntie</span></p>
<p class="toc1"><span href="#/index_split_027" title="Link target outside of Sample">25. Promises Kept</span></p>
<p class="toc1"><span href="#/index_split_028" title="Link target outside of Sample">26. Chasing Ghosts</span></p>
<p class="toc1"><span href="#/index_split_029" title="Link target outside of Sample">27. Spit and Dust</span></p>
<p class="toc1"><span href="#/index_split_030" title="Link target outside of Sample">28. Floor 57</span></p>
<p class="toc1"><span href="#/index_split_031" title="Link target outside of Sample">29. The Illusion of Poison</span></p>
<p class="toc1"><span href="#/index_split_032" title="Link target outside of Sample">30. A Little War</span></p>
<p class="toc1"><span href="#/index_split_033" title="Link target outside of Sample">31. Mr. Piggy Goes to School</span></p>
<p class="toc1"><span href="#/index_split_034" title="Link target outside of Sample">32. Abseiling Online</span></p>
<p class="toc1"><span href="#/index_split_035" title="Link target outside of Sample">33. Flying a Flag</span></p>
<p class="toc1"><span href="#/index_split_036" title="Link target outside of Sample">34. Finding Viggo</span></p>
<p class="toc1"><span href="#/index_split_037" title="Link target outside of Sample">35. Black Widows</span></p>
<p class="toc1"><span href="#/index_split_038" title="Link target outside of Sample">36. Promises Broken</span></p>
<p class="toc1"><span href="#/index_split_039" title="Link target outside of Sample">37. Nobody’s Asset</span></p>
<p class="toc1"><span href="#/index_split_040" title="Link target outside of Sample">38. Someone You Need</span></p>
<p class="toc1"><span href="#/preview" title="Link target outside of Sample">Preview: <i>Survival</i></span></p>
<p class="toc1"><span href="#/index_split_041" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?3758fa01